import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import { Btn, Input } from '../../components/UI';
import api from '../../utils/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', source: 'request_demo' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/api/website-leads', form); setSent(true); } catch {}
    finally { setLoading(false); }
  };

  return (
    <>
      <Navbar />
      <div style={{ padding: '100px 24px 80px', maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: 'var(--green-dim)', color: 'var(--green)', padding: '6px 16px', borderRadius: 100, fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 16 }}>Contact</div>
        <h1 style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 40, marginBottom: 16 }}>Get in <span style={{ color: 'var(--green)' }}>Touch</span></h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: 16, maxWidth: 600, margin: '0 auto 48px', lineHeight: 1.7 }}>If you want to capture leads directly from your website and receive them instantly in WhatsApp, our platform can help you.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 16, marginBottom: 48 }}>
          {[['📧','EMAIL','halo@msdiscoveries.com'],['📞','PHONE','+91 9443724724'],['🕐','SUPPORT HOURS','Mon–Sat, 10AM–6PM IST']].map(([icon,label,val]) => (
            <div key={label} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, padding: 24 }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{icon}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 8 }}>{label}</div>
              <div style={{ color: 'var(--green)', fontWeight: 600, fontSize: 14 }}>{val}</div>
            </div>
          ))}
        </div>
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: 40, maxWidth: 500, margin: '0 auto', textAlign: 'left' }}>
          <h2 style={{ fontFamily: 'Sora', marginBottom: 8 }}>Send us a Message</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 24 }}>Fill in your details and we will get back to you shortly.</p>
          {sent ? <div style={{ color: 'var(--green)', textAlign: 'center', padding: '20px 0', fontWeight: 600 }}>✅ Thank you! We will contact you shortly.</div> : (
            <form onSubmit={handleSubmit}>
              <Input label="Your Name *" value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Your name" required />
              <Input label="Email ID *" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="your@email.com" required />
              <Input label="Phone Number *" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+91 9876543210" required />
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>How can we help?</label>
                <select value={form.source} onChange={e => setForm({...form, source: e.target.value})} style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '11px 14px', color: 'var(--text)', fontSize: 14 }}>
                  <option value="request_demo">Request Demo</option>
                  <option value="get_pricing">Get Pricing</option>
                  <option value="talk_to_sales">Talk to Sales</option>
                </select>
              </div>
              <Btn type="submit" disabled={loading} full size="lg">{loading ? 'Sending...' : 'Send Message'}</Btn>
            </form>
          )}
        </div>
      </div>
    </>
  );
}